import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\EquipmentController::index
* @see app/Http/Controllers/EquipmentController.php:21
* @route '/stroje'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/stroje',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\EquipmentController::index
* @see app/Http/Controllers/EquipmentController.php:21
* @route '/stroje'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\EquipmentController::index
* @see app/Http/Controllers/EquipmentController.php:21
* @route '/stroje'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\EquipmentController::index
* @see app/Http/Controllers/EquipmentController.php:21
* @route '/stroje'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\EquipmentController::show
* @see app/Http/Controllers/EquipmentController.php:70
* @route '/stroje/{equipment}'
*/
export const show = (args: { equipment: string | { slug: string } } | [equipment: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/stroje/{equipment}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\EquipmentController::show
* @see app/Http/Controllers/EquipmentController.php:70
* @route '/stroje/{equipment}'
*/
show.url = (args: { equipment: string | { slug: string } } | [equipment: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { equipment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { equipment: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            equipment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        equipment: typeof args.equipment === 'object'
        ? args.equipment.slug
        : args.equipment,
    }

    return show.definition.url
            .replace('{equipment}', parsedArgs.equipment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\EquipmentController::show
* @see app/Http/Controllers/EquipmentController.php:70
* @route '/stroje/{equipment}'
*/
show.get = (args: { equipment: string | { slug: string } } | [equipment: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\EquipmentController::show
* @see app/Http/Controllers/EquipmentController.php:70
* @route '/stroje/{equipment}'
*/
show.head = (args: { equipment: string | { slug: string } } | [equipment: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

const equipment = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
}

export default equipment